module.exports = __webpack_public_path__ + "img/i-swipe-3.56259d50.png";